import Form from 'cerebral-module-forms/Form'
import createAddressField from '../helpers/createAddressField'

export default function prepareAddressFields({ state }) {
  let { addresstypes, registration } = state.get('client')
  addresstypes.forEach(type => {
    let registrationObj = {}
    let path = `client.registrating.current.${type}`
    registration.forEach(registration => {
      let performCreateField = true
      if (registration.excludeFrom && registration.excludeFrom.length > 0) {
        if (registration.excludeFrom.indexOf(type) !== -1) {
          performCreateField = false
        }
      }
      if (performCreateField) {
        registrationObj[registration.identifier] = createAddressField(
          registration,
          path
        )
      }
    })
    state.set(path, Form(registrationObj))
  })
}



// WEBPACK FOOTER //
// ./src/modules/app/actions/prepareAddressFields.js